import { useEffect, useState } from "react";

const navLinks = [
  { href: "#featured", label: "今日爆点" },
  { href: "#dorm", label: "宿舍迷惑" },
  { href: "#classroom", label: "课堂社死" },
  { href: "#ranking", label: "吃瓜热榜" },
  { href: "#duo", label: "同桌与群聊" },
  { href: "#gossip", label: "课间八卦" },
  { href: "#faq", label: "常见问题" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goSubmit = () => {
    setOpen(false);
    document.getElementById("submit")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      className={`fixed top-0 left-0 z-50 w-full transition-colors duration-300 ${
        scrolled
          ? "bg-background-50/90 backdrop-blur-md border-b border-background-200"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between gap-4 px-4 md:px-6">
        <a href="#top" className="flex shrink-0 items-center gap-2.5">
          <span className="flex h-10 w-10 items-center justify-center rounded-2xl bg-primary-500 text-xl text-white">
            🤣
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-xl tracking-wide text-foreground-900">
              校园爆笑社
            </span>
            <span className="mt-1 text-[10px] tracking-[0.2em] text-foreground-500">
              课间吃瓜聚集地
            </span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 lg:flex">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="whitespace-nowrap rounded-full px-3.5 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-primary-100/70 hover:text-primary-800"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <button
            onClick={goSubmit}
            className="hidden whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-bold text-white transition-colors hover:bg-primary-600 sm:block"
          >
            立即投稿
          </button>
          <button
            onClick={() => setOpen((v) => !v)}
            aria-label="菜单"
            className="flex h-10 w-10 items-center justify-center rounded-xl border border-background-200 bg-background-50 text-foreground-800 lg:hidden"
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 lg:hidden">
          <div className="mx-auto flex max-w-7xl flex-col gap-1 px-4 py-3">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="rounded-xl px-3 py-2.5 text-sm font-medium text-foreground-700 hover:bg-primary-100/70"
              >
                {l.label}
              </a>
            ))}
            <button
              onClick={goSubmit}
              className="mt-1 whitespace-nowrap rounded-xl bg-primary-500 px-4 py-2.5 text-sm font-bold text-white"
            >
              立即投稿
            </button>
          </div>
        </div>
      )}
    </header>
  );
}